import type { NicheConfig } from "../../types/niche";

export const multipropriedadeConfig: NicheConfig = {
  id: "niche-multipropriedade",
  slug: "multipropriedade",
  name: "Rescisão Tempestiva de Multipropriedade",
  metaTitle: "Cancelamento de Multipropriedade em 7 Dias | Notificação Extrajudicial Art. 49 CDC | Gepeto",
  metaDescription:
    "Gere sua notificação extrajudicial para cancelar contrato de multipropriedade no prazo de 7 dias, com fundamento no Art. 49 do CDC e na Lei do Distrato (Lei nº 13.786/18).",
  badge: "Protocolo Digital - Art. 49 CDC",
  headline: "Cancele seu Contrato de Multipropriedade no Prazo de 7 Dias",
  subheadline:
    "Gere sua Notificação Extrajudicial formal fundamentada no Art. 49 do CDC e na Lei do Distrato (Lei nº 13.786/18). Exija o estorno integral de arras e entradas.",
  targetPain:
    "Assinou um contrato de multipropriedade durante uma apresentação em viagem, sob pressão comercial, e se arrependeu? O prazo legal de reflexão é curto — cada dia conta.",
  price: 147,
  formFields: [
    {
      name: "incorporadora",
      label: "Rede/Incorporadora",
      type: "select",
      placeholder: "Selecione a rede",
      required: true,
      step: 1,
      options: ["Gramado Parks", "WAM Comercialização", "GAV Resorts", "Natos", "Beach Park", "Privé", "Outra"],
    },
    {
      name: "incorporadoraOutra",
      label: "Nome da Incorporadora",
      type: "text",
      placeholder: "Razão social ou nome comercial",
      required: true,
      step: 1,
      dependsOn: { field: "incorporadora", value: "Outra" },
    },
    { name: "dataAssinatura", label: "Data de Assinatura do Contrato", type: "date", required: true, step: 1 },
    {
      name: "formaPagamento",
      label: "Forma de Pagamento da Entrada",
      type: "select",
      placeholder: "Selecione a forma",
      required: true,
      step: 1,
      options: ["Cartão de Crédito", "PIX", "Boleto"],
    },
    { name: "valorEntrada", label: "Valor da Entrada (R$)", type: "currency", placeholder: "0,00", required: true, step: 1 },
    { name: "nomeCompleto", label: "Nome Completo", type: "text", placeholder: "Como consta no contrato", required: true, step: 2 },
    { name: "cpf", label: "CPF", type: "cpf", placeholder: "000.000.000-00", required: true, step: 2 },
    { name: "email", label: "E-mail", type: "email", placeholder: "voce@exemplo.com.br", required: true, step: 2 },
    { name: "whatsapp", label: "WhatsApp", type: "tel", placeholder: "(00) 00000-0000", required: true, step: 2 },
    {
      name: "aceite",
      label: "Li e aceito os Termos de Uso e declaro que as informações são verdadeiras",
      type: "checkbox",
      required: true,
      step: 2,
    },
  ],
};
